/* eslint-disable */
import 'nodelist-foreach-polyfill';
import Swiper from 'swiper/dist/js/swiper'; // https://github.com/nolimits4web/Swiper/issues/2263
import 'swiper/dist/css/swiper.css';
import './testimonials-slider.scss';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-testimonials-slider-wrapper]').forEach((wrapper) => {
    const container = wrapper.querySelector('[data-swiper-container]');
    const nextEl = wrapper.querySelector('[data-next-el]');
    const prevEl = wrapper.querySelector('[data-prev-el]');
    const swiper = new Swiper(container, { // eslint-disable-line
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      speed: 500,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl,
        prevEl,
      },
      keyboard: true,
    });
  });
});
